import { Component, input, OnChanges } from "@angular/core";
import { SafePipe } from "common/download/safe.pipe";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-chatbot-welcome",
	templateUrl: "./chatbot-welcome.component.html",
	styleUrls: ["./chatbot-welcome.component.scss"],
	imports: [SafePipe, TranslateModule],
})
export class ChatbotWelcomeComponent implements OnChanges {
	protected CHIPSELECTION_MESSAGE = "chatbot.welcome.viewselect";
	protected STANDARD_MESSAGE = "chatbot.welcome.standard";

	readonly showViewChips = input<boolean>(false);

	readonly customMessageHtml = input<string | null>("");

	showCustomMessageHtml: boolean = false;
	welcomeMessage: string = this.STANDARD_MESSAGE;

	ngOnChanges(): void {
		const customMessageHtml = this.customMessageHtml();
		this.showCustomMessageHtml = !this.showViewChips() && customMessageHtml !== null && customMessageHtml.length > 0;

		this.welcomeMessage = this.showViewChips() ? this.CHIPSELECTION_MESSAGE : this.STANDARD_MESSAGE;
	}
}
